import typography from "../typography";

export default {
  root: {
    ...typography.body1,
    "&:last-child": {
    }
  },
};
